/**
 * Labstep
 *
 * @module components/OrderRequest/SearchSelect
 * @desc Search select for order request
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { OrderRequest } from 'labstep-web/models/order-request.model';
import type React from 'react';
import type { OrderRequestSearchSelectProps } from './types';

export const OrderRequestSearchSelect: React.FC<
  OrderRequestSearchSelectProps
> = ({ onChange, params = {}, activeGroup, getOptionLabel }) => (
  <SearchSelect
    entityName={OrderRequest.entityName}
    params={{ group_id: activeGroup?.id, ...params }}
    onChange={onChange}
    getOptionLabel={getOptionLabel}
    autoFocus
  />
);

export default withActiveGroup(OrderRequestSearchSelect);
